import SuperFetch from 'library/helpers/superFetch';
import { call } from 'redux-saga/effects';
import { Notification } from 'zComponents/atoms';

// 👇 Function to create address
export function* createAddressSaga(addressData) {
	try {
		const response = yield call(() => SuperFetch.post(`/addresses`, addressData));
		if (response.statusCode === 200) {
			Notification('success', 'Address created successfully.');
		} else {
			throw Error('Failed to create address.');
		}
	} catch (error) {
		Notification('error', error.message || 'Address creation failed.');
		throw error;
	}
}

// 👇 Functions to update address
export function* updateAddressSaga(addressID, addressData) {
	try {
		delete addressData.entityID;
		delete addressData.entityTypeID;

		const response = yield call(() => SuperFetch.patch(`/addresses/${addressID}`, addressData));
		if (response.statusCode === 200) {
			Notification('success', 'Address updated successfully.');
		} else {
			throw Error('Failed to update address.');
		}
	} catch (error) {
		Notification('error', error.message || 'Address update failed.');
		throw error;
	}
}
